module.exports = __webpack_public_path__ + "static/media/button-border-2.5dcb5516.svg";